import { defineMessages } from 'react-intl';

export default defineMessages({
  resetPassword: 'Zresetuj hasło',
  login: 'Login',
  password: 'Hasło',
  confirmPassword: 'Powtórz hasło',
  log: 'Resetuj',
});
